import { render, staticRenderFns } from "./AttendanceTransferInput.vue?vue&type=template&id=151c1b47&scoped=true"
import script from "./AttendanceTransferInput.vue?vue&type=script&lang=js"
export * from "./AttendanceTransferInput.vue?vue&type=script&lang=js"
import style0 from "./AttendanceTransferInput.vue?vue&type=style&index=0&id=151c1b47&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c1b47",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip});
